exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".collectbtndiv[data-v-b5aa53e2]{cursor:pointer;margin-left:16px}.collectbtndiv img[data-v-b5aa53e2]{width:16px;height:16px}.collectbtndiv .btntext[data-v-b5aa53e2]{margin-left:4px;font-size:12px;color:#999}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b5aa53e2","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/packages/collect/um-collect.vue
// module id = 111
// module chunks = 0